import {axiosBffFetch, FetcherOptions} from '../../axios/axiosBffFetch';
import type {ProfileApiResultVo} from '../../common/shared/api/nicolas/vo/UserVo.interface';
import {trimUndefinedFromObject} from '../../common/util/trimUndefinedFromObject';
import {UserAndCashQueryVariables} from '../../graphql/generated/types';

/**
 * 사용자 프로필 조회
 *
 * Origin: pageNicolasApi.getProfile
 * API: POST /api/v1/user/get_profile
 */
export async function postGatewayUserGetProfile(
  variables?: UserAndCashQueryVariables,
  options?: FetcherOptions
): Promise<ProfileApiResultVo> {
  const {authInput} = variables ?? {};
  const response = await axiosBffFetch(
    '/api/gateway/api/v1/user/get_profile',
    {
      method: 'POST',
      data: authInput
        ? trimUndefinedFromObject({
            app_user_id: authInput.appUserId,
            access_token: authInput.accessToken,
          })
        : undefined,
    },
    options
  );
  return response.data;
}
